import updateURL from './update-url'
import getParameters from './get-parameters'

export default (key, value) => {
  const parameters = getParameters()
  parameters[key] = value
  updateURL(parameters)
}
